<template lang='pug'>
  .sticky-wrap(v-bind:class="{fixed: fixed, stopped: stopped}")
    slot
</template>

<script>
  export default {
    props: {
      bottomRelative: Boolean,
      stopAt: String
    },

    data() {
      return {
        fixed: false,
        stopped: false,
        interval: null
      }
    },

    methods: {
      update() {
        var elementTop = this.$el.getBoundingClientRect().top;
        var shouldBeFixed = this.fixed;
        var shouldBeStopped = this.stopped;

        if (this.top != elementTop) {
          var elementBottom = elementTop + this.$el.clientHeight;
          var windowHeight = this.$root.windowData.height;

          shouldBeFixed = elementBottom <= 0 || (this.bottomRelative && (elementBottom + windowHeight) <= 0);

          if (this.stopAt) {
            var stopAtElement = document.getElementById(this.stopAt);
            var stopAtTop = stopAtElement.getBoundingClientRect().top;
            shouldBeStopped = stopAtTop - windowHeight <= 0;
          }

          if (shouldBeFixed != this.fixed) {
            this.fixed = shouldBeFixed;
            this.$emit(this.fixed ? 'fixed' : 'unfixed');
          }

          if (shouldBeStopped != this.stopped) {
            this.stopped = shouldBeStopped;
            this.$emit(this.stopped ? 'stopped' : 'unstopped');
          }
        }
      }
    },

    mounted() {
      var self = this;
      self.update();
      self.interval = window.setInterval(function() {
        self.update();
      }, 200);
    },

    beforeDestroy() {
      window.clearInterval(this.interval);
    }
  }
</script>
